// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7b26bf9e","455":"c6e20e9a","977":"0264aee7"}[chunkId] + ".chunk.js";
};